"use client";
import { NavigationArrowWrapper } from "@areahub/ui/components/navigation-arrow/navigation-arrow-wrapper";
import { Box, Stack } from "@chakra-ui/react";

export default function PressPageLayout(props) {
  return (
    <>
      <Box maxW="1440px" mx="auto" px="5" my="24">
        <Stack as="article" flexDirection="row" justifyContent="center">
          <Box
            maxW="container.md"
            mx="auto"
            px={{ base: "6", md: "8" }}
            alignSelf="flex-start"
            mt="0"
          >
            {props.children}
          </Box>
        </Stack>
      </Box>
      <NavigationArrowWrapper />
    </>
  );
}
